<template>
  <div class="p-grid p-mt-4" v-if="user">
    <div class="p-col-12 p-md-12 p-lg-6 p-fluid info-card">
      <Panel :header="$t('General information')">
        <div class="panel-inner">
          <div class="panel-info-block-grid">
            <div class="panel-info-block-label p-p-1">{{$t('Type')}}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="user.type">{{ customerTypeLabel(user.type) }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Customer') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <CustomerData :user="user"/>
            </div>

            <template v-if="isLegalEntity && user.primaryRepresentative">
              <div class="panel-info-block-label p-p-1">{{ $t('primaryRepresentativeLabel') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <CustomerData :user="user.primaryRepresentative"/>
              </div>
            </template>

            <div class="panel-info-block-label p-p-1">{{ $t('Phone') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="computedPhoneNumber">{{ computedPhoneNumber }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Email') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="user.email">{{ user.email }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('creationLocation') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="user.creationLocationName">{{ user.creationLocationName }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <template v-if="isLegalEntity">
              <div class="panel-info-block-label p-p-1">{{ $t('Reg. number') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <template v-if="user.reg_number">{{ user.reg_number }}</template>
                <i v-else class="ti-minus"/>
              </div>

              <div class="panel-info-block-label p-p-1">{{ $t('VAT number') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <template v-if="user.vat_number">{{ user.vat_number }}</template>
                <i v-else class="ti-minus"/>
              </div>
            </template>
          </div>
        </div>
      </Panel>
    </div>

    <div class="p-col-12 p-md-12 p-lg-6 p-fluid info-card">
      <Panel :header="$t('Additional information')">
        <div class="panel-inner">
          <div class="panel-info-block-grid">
            <template v-if="isLegalEntity && user.credit_limit">
              <div class="panel-info-block-label p-p-1">{{ $t('Credit limit') }}:</div>
              <div class="panel-info-block-value p-p-1">
                {{ formatCurrency(user.credit_limit) }}
              </div>
            </template>

            <template v-if="isLegalEntity">
              <div class="panel-info-block-label p-p-1">{{ $t('Days to pay') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <span v-if="user.days_to_pay">{{ user.days_to_pay }}</span>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <div class="panel-info-block-label p-p-1">{{ $t('Services discount') }}:</div>
            <div class="panel-info-block-value p-p-1">
              {{ formatDecimal(user.services_discount) }}%
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Products discount') }}:</div>
            <div class="panel-info-block-value p-p-1">
              {{ formatDecimal(user.products_discount) }}%
            </div>


            <template v-if="isLegalEntity">
              <div class="panel-info-block-label p-p-1">{{ $t('Address') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <template v-if="user.address">
                  {{ addressLine(user.address) }}
                </template>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <div class="panel-info-block-label p-p-1">{{ $t('Comment') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="user.comment">{{ user.comment }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Created') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <template v-if="user.created_at">
                {{ formatBy(user.created_at, user.creator) }}
              </template>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Updated') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <template v-if="user.updated_at">
                {{ formatBy(user.updated_at, user.updatedBy) }}
              </template>
              <i v-else class="ti-minus"/>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  </div>

</template>

<script>
// import settings from '@/settings.js'
import constants from '@/constants'
import formatMixins from '@/mixins/formatMixins'
import CustomerTypes from "@/translations/CustomerTypes";
import CustomerData from "@/components/CustomerData.vue";
import labelMixin from "@/mixins/labelMixin";

export default {
  components: { CustomerData },
  mixins: [ formatMixins, labelMixin ],
  emits: ['change-customer-status'],
  props: {
    user: {
      type: Object,
      default: null
    },
    customerIsLoading: {
      type: Boolean,
      default: false
    },
  },
	data() {
		return {
      // userId: null,
      // isLoading: true,
      // settings,
      constants,
      CustomerTypes,
		}
	},
  methods: {
    customerTypeLabel(type) {
      const customerType = this.CustomerTypes.find(item => Number(item.type) === Number(type))

      return customerType?.label?.[this.$i18n.locale] || customerType?.label?.en || ''
    },
  },
  computed: {
    computedPhoneNumber() {
      const primaryRepresentative = this.user?.primaryRepresentative
      const customer = this.user
      if (primaryRepresentative && primaryRepresentative.phone_code && primaryRepresentative.phone_number) {
        return '+' + primaryRepresentative.phone_code + ' ' + primaryRepresentative.phone_number
      } else if (customer && customer.phone_code && customer.phone_number) {
        return '+' + customer.phone_code + ' ' + customer.phone_number
      } else {
        return null
      }
    },
    isLegalEntity() {
      return Number(this.user?.type) === Number(this.constants.userTypes.legal_entity)
    },
  }
}
</script>